(() => {
  document.documentElement.classList.add('mobile-site-ready');
  const rails = document.querySelectorAll('.mobile-rail');
  rails.forEach((rail) => rail.addEventListener('keydown', (event) => {
    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
    rail.scrollBy({ left: event.key === 'ArrowRight' ? rail.clientWidth * .75 : -rail.clientWidth * .75, behavior: 'smooth' });
  }));
})();
